export const reportsData = [
    {
        id: 1,
        report_title: "Front Office",
        report_lists: [
            { id: 1, name: "Arrival Report" },
            { id: 2, name: "Departure Report" },
            { id: 3, name: "Night Audit Report" },
            { id: 4, name: "Police Enquiry Report" },
            { id: 5, name: "Management Block Report" },
            { id: 6, name: "Out of Order Room Report" },
            { id: 7, name: "No Show Report" },
            { id: 8, name: "Room Status Report" },
            { id: 9, name: "Reviews Tracking Report" },
            { id: 10, name: "IOT Occupancy Issues Report" },
            { id: 11, name: "Maintenance Report" },
        ],
    },
    {
        id: 2,
        report_title: "Accounting",
        report_lists: [
            { id: 1, name: "Room Wise Revenue Report" },
            { id: 2, name: "Date Wise Revenue Report" },
            { id: 3, name: "Checkout based Accounting Report" },
            { id: 4, name: "Item Consumption Report" },
            { id: 5, name: "Payments Report" },
            { id: 6, name: "POS Report" },
            { id: 7, name: "Payment Void Report" },
            { id: 8, name: "Expense Report" },
            { id: 9, name: "City Ledger Payment Report" },
        ],
    },
    {
        id: 3,
        report_title: "Management",
        report_lists: [
            { id: 1, name: "Hotel Sales Report" },
            { id: 2, name: "Company Performance" },
            { id: 3, name: "Monthly Performance Report" },
            { id: 4, name: "Daily Forecast Report" },
            { id: 5, name: "Monthly P&L" },
            { id: 6, name: "Contribution Report" },
        ],
    },
    {
        id: 4,
        report_title: "Groups",
        report_lists: [
            { id: 1, name: "Group Sales Report" },
            { id: 2, name: "Group P&L" },
            { id: 3, name: "Group Maintenance Report" },
            { id: 4, name: "Group Date Wise Revenue Report" },
            { id: 5, name: "Group IOT Occupancy Issues Report" },
            { id: 6, name: "Group IOT Device Monthly Status Report" },
            { id: 7, name: "Group Cash Balance Report" },
            { id: 8, name: "Group Weekly Meeting Report" },
            { id: 9, name: "Group Payments Report" },
            { id: 10, name: "Group Expense Report" },
            { id: 11, name: "Group Availability Mismatch Report (PMS vs CM)" },
            { id: 12, name: "Group Reconciliation Report" },
        ],
    },
];




















